import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';
import {
  UpdateOrgContractAnalysisDocument,
  type UpdateOrgContractAnalysisMutationVariables,
} from '@/graphql/generated/graphql';

export type OrgContractAnalysisUpdateInput = Omit<
  UpdateOrgContractAnalysisMutationVariables,
  'ItemId'
>;

export const useUpdateOrgContractAnalysis = () => {
  const mutation = useMutation({
    mutationKey: ['update-org-contract-analysis'],
    mutationFn: (variables: UpdateOrgContractAnalysisMutationVariables) =>
      graphqlClient.request(UpdateOrgContractAnalysisDocument, variables),
  });

  return {
    ...mutation,
    updateOrgContractAnalysis: mutation.mutate,
    updateOrgContractAnalysisAsync: mutation.mutateAsync,
  };
};

export const UPDATE_ORG_CONTRACT_ANALYSIS_MUTATION = UpdateOrgContractAnalysisDocument;
